import { LogEvents, logger } from 'lib/common/components/LoggerController';

import quickConnectTypes from '../constants/quickConnectTypes';
import toast from '../utils/toast';

export default async function getTransferEndpoint({ fetch_, config, type, identifier, asEndpointObject = false }) {
  try {
    const transferResponse = await fetch_(`${config.AGENT_SERVICE_V2_URL}/connect/endpoint/${type}/${identifier}`, {
      method: 'GET',
    });

    const endpointARN = (await transferResponse.json()).data;

    return asEndpointObject
      ? {
          agentLogin: null,
          endpointARN,
          endpointId: endpointARN,
          name: identifier,
          phoneNumber: null,
          queue: null,
          type: type === quickConnectTypes.AGENT ? connect.EndpointType.AGENT : connect.EndpointType.QUEUE,
        }
      : endpointARN;
  } catch (error: any) {
    logger.error(LogEvents.TRANSFER_ENDPOINT_LOAD_FAILED, { error });

    if (error.status === 404) {
      toast(
        'error',
        `Oops, it looks like something hasn't been set up correctly. Try getting in touch with your Administrator.`
      );
      return '';
    }

    toast('error', `Something went wrong transferring to this Agent/Queue. Please try again.`);

    return '';
  }
}
